import type Quill from 'quill/core';
import type { Parchment } from 'quill/core';
import React from 'react';
import { MenuItem } from '../../components/Menu';
import embedIcon from '../../icons/non-prefilled/16x16/embed.svg';
import AttachmentMention from '../formats/AttachmentMention';
import replaceEmbedBlotWith from '../utils/replaceEmbedBlotWith';

interface ConvertIntoEmbedMenuItemProps {
  quill: Quill;
  blot: Parchment.EmbedBlot | AttachmentMention;
}

const ConvertIntoEmbedMenuItem = ({
  quill,
  blot,
}: ConvertIntoEmbedMenuItemProps) => (
  <MenuItem
    icon={embedIcon}
    onClick={() => {
      if (blot instanceof AttachmentMention) {
        replaceEmbedBlotWith(
          quill,
          blot,
          {
            attachment: blot.getAttachmentFiles(),
          },
          blot.formats(),
        );
      } else {
        const { id, type, params } = blot.statics.value(blot.domNode);
        replaceEmbedBlotWith(quill, blot, { embed: { type, id, params } });
      }
    }}
    testId="convertIntoEmbedMenuItem"
  >
    Convert into embed
  </MenuItem>
);

export default ConvertIntoEmbedMenuItem;
